import { render, staticRenderFns } from "./sidepanel.vue?vue&type=template&id=39e9c342&"
import script from "./sidepanel.vue?vue&type=script&lang=js&"
export * from "./sidepanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports